import projectInfo from '../../package.json';

// change urls for development env
const test = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test' || process.env.REACT_APP_DEV === '1';
if (test) {
  console.log('env: test');
  if (window.location.href.indexOf('localhost') !== -1) {
    window.local = true;

    // custom config keys
    //-------------------
    window.config.withClipboard = true;
    // window.config.use_extended_app_list = true;
    // window.config.use_subscription_balance = true;
    // window.config.test = true;
    window.config.use_lang = true;
    // window.config.use_client_login = true;
    // window.config.use_subscription_balance = true;
    window.config.benefit_reasons = ['Доставка товара'];
    window.config.penalty_default = 'Пенальти';
    window.config.adv = {
      sidescreen: [1080, 1920],
    };

    window.config.network.additional_reports_url = [
      { link: 'http://10.100.62.208:8080/birt/frameset?__report=report1.rptdesign', title: 'Время присутствия' },
      { link: 'http://10.100.62.208:8080/birt/frameset?__report=report2.rptdesign', title: 'Время присутствия без оплаты' },
      { link: 'http://10.100.62.208:8080/birt/frameset?__report=report3.rptdesign', title: 'Распределение оплат и передвижений' },
      { link: 'http://10.100.62.208:8080/birt/frameset?__report=report4.rptdesign', title: 'Распределение оплат и передвижений (отчет)' },
      { link: 'http://10.100.62.208:8080/birt/frameset?__report=report5.rptdesign', title: 'Распределение оплат и передвижений без оплат' },
      { link: 'http://10.100.62.208:8080/birt/frameset?__report=report6.rptdesign', title: 'Распределение оплат и передвижений без оплат краткий' },
    ];

    // custom config urls
    //-------------------

    // tumen
    // window.config.network.api_url = 'https://crm.tumen.stage.caps.cursusts.ru/api';

    // igora
    // // window.config.network.api_url = 'https://crm.igora.stage.caps.cursusts.ru/api';

    // локальный бэк
    // window.config.network.api_url = 'http://127.0.0.1:8088/api';

    // simf
    // window.config.network.api_url = 'https://crm.simferopol.stage.caps.cursusts.ru/api';

    // gcup
    // window.config.network.api_url = 'https://crm.gcup.stage.caps.cursusts.ru/api';

    // beg
    // window.config.network.api_url = 'https://crm.begishevo.stage.caps.cursusts.ru/api';

    // urengoy
    window.config.network.api_url = 'https://crm.urengoy.stage.caps.cursusts.ru/api';

    // stockman
    window.config.network.api_url = 'https://crm.stockmann.stage.caps.cursusts.ru/api';

    // /git stockmann/caps-cpa-backend checkout develop CAPS2-2347
    // /pull stockmann/caps-cpa-backend develop
    // /status all/caps-cs-backend

    // parma menskings
    // window.config.network.api_url = 'http://10.105.0.160/api';

    // gastromoll
    // window.config.network.api_url = 'http://172.27.1.40/api';

    // Спартаковская
    // window.config.network.api_url = 'http://10.116.0.201/api';

    // Мегаспорт
    // window.config.network.api_url = 'http://10.2.47.201/api';

    // sportakovskaya
    // window.config.network.api.url = 'http://10.116.0.201/api';

    // msk
    // window.config.network.api_url = 'http://172.16.134.201/api';
    // route add 172.16.134.0 mask 255.255.255.0 10.168.0.1

    // prod gcup
    // window.config.network.api_url = 'http://10.15.252.234:3080/api';

    // prod astrus
    // window.config.network.api_url = 'http://192.168.171.201/api';

    // prod nn
    // window.config.network.api_url = 'http://10.100.18.8/api';

    // gcup central
    // window.config.network.api_url = 'http://10.131.1.131/api';

    // window.config.network.api_url = 'http://10.105.0.117/api';

    // samara
    // window.config.network.api_url = 'http://10.105.0.215/api';

    // prod
    // window.config.network.api_url = 'http://10.77.5.201/api';
  }
  // window.config.use_lang = true;
}

window.config.req = ' *';

console.log('version: ' + projectInfo.version);

// replace at
String.prototype.replaceAt = function (index, replacement) {
  return this.substring(0, index) + replacement + this.substring(index + replacement.length);
};

export const config = window.config;

export default config;
